import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import { Button } from "react-bootstrap";

const IconButton = forwardRef(
  (
    { icon, iconAlign = "left", iconClassName, transform, children, ...rest },
    ref
  ) => (
    <Button {...rest} ref={ref}>
      {iconAlign === "right" && children}
      <FontAwesomeIcon
        icon={icon}
        className={classNames(iconClassName, {
          "me-1": children && iconAlign === "left",
          "ms-1": children && iconAlign === "right",
        })}
        transform={transform}
      />
      {iconAlign === "left" || iconAlign === "middle" ? children : false}
    </Button>
  )
);

IconButton.displayName = "IconButton";

IconButton.propTypes = {
  ...Button.propTypes,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  children: PropTypes.any,
  iconAlign: PropTypes.oneOf(["left", "right", "middle"]),
  iconClassName: PropTypes.string,
  transform: PropTypes.string,
};

export default IconButton;
